import React from 'react';
import { Icon } from '@iconify/react';
import {
  formatPlanDeComMoney,
  getPlanDeComLigneTotal,
  getPlanDeComLigneSupportGroups,
  isPlanDeComLigneFilled,
  monthTitle,
} from '../../utils/planDeComCalendrierUi';

const PlanDeComMonthCard = ({ ligne, onOpen, locked = false }) => {
  const filled = isPlanDeComLigneFilled(ligne);
  const supports = getPlanDeComLigneSupportGroups(ligne);
  const net = getPlanDeComLigneTotal(ligne);
  const brut = ligne?.calcules?.V ?? ligne?.calcules?.F;

  return (
    <button
      type="button"
      className={`kkp-pdc-month-card ${filled ? 'kkp-pdc-month-card--filled' : 'kkp-pdc-month-card--empty'}${locked ? ' kkp-pdc-month-card--locked' : ''}`}
      onClick={() => onOpen?.(ligne)}
      aria-disabled={locked || undefined}
    >
      <div className="kkp-pdc-month-card__header">
        <div>
          <div className="kkp-pdc-month-card__mois">{monthTitle(ligne?.mois)}</div>
          <div className="kkp-pdc-month-card__annee">{ligne?.annee || '—'}</div>
        </div>
        {filled ? (
          <span className="kkp-pdc-month-card__badge">
            {ligne?.type_campagne || 'Campagne'}
          </span>
        ) : (
          <span className="kkp-pdc-month-card__badge kkp-pdc-month-card__badge--muted">À compléter</span>
        )}
      </div>

      {filled ? (
        <>
          <ul className="kkp-pdc-month-card__supports">
            {supports.length === 0 && (
              <li className="kkp-pdc-month-card__support kkp-pdc-month-card__support--empty">
                Aucun support
              </li>
            )}
            {supports.map((support) => (
              <li key={support.key} className="kkp-pdc-month-card__support" title={support.displayLabel || support.label}>
                <div className="kkp-pdc-month-card__support-label">
                  <span className="kkp-pdc-month-card__support-text">
                    {support.tarifLibelle || support.label}
                  </span>
                  {support.qty > 1 ? (
                    <span className="kkp-pdc-month-card__support-qty">x{support.qty}</span>
                  ) : null}
                </div>
                {support.dateLabel ? (
                  <div className="kkp-pdc-month-card__support-date">{support.dateLabel}</div>
                ) : null}
                {support.remises?.length ? (
                  <div className="kkp-pdc-month-card__remises">
                    {support.remises.map((remise) => (
                      <span
                        key={`${support.field}-${remise.key}-${remise.label}`}
                        className="kkp-pdc-month-card__remise"
                      >
                        {remise.label}
                      </span>
                    ))}
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
          <div className="kkp-pdc-month-card__footer">
            <div>
              <span className="kkp-pdc-month-card__amount-label">Catalogue</span>
              <strong>{formatPlanDeComMoney(brut)}</strong>
            </div>
            <div className="text-end">
              <span className="kkp-pdc-month-card__amount-label">Total</span>
              <strong className="kkp-pdc-month-card__amount-net">{formatPlanDeComMoney(net)}</strong>
            </div>
          </div>
        </>
      ) : (
        <div className="kkp-pdc-month-card__empty">
          <Icon
            icon={locked ? 'mdi:lock-outline' : 'mdi:plus-circle-outline'}
            className="kkp-pdc-month-card__empty-icon"
          />
          <span>{locked ? 'Entreprise et commercial requis' : 'Ajouter une campagne'}</span>
        </div>
      )}
    </button>
  );
};

export default PlanDeComMonthCard;
